export enum Environment {
  Preview = 'preview',
  Production = 'production',
  Qa = 'qa', // DX has no QA environment; nav in QA deploys maps this to the production name+token
}
